import React, { useEffect, useState } from "react";
import Breadcrumbs from "common/Breadcrumbs/Breadcrumbs";
import { P } from "common/P/P";
import { routeConstants } from "navigation/routeConstants";
import { Button } from "common/Button/Button";
import { ReactComponent as AddLetterIcon } from "common/assets/icons/add-page.svg";
import Pagination from "components/Pagination/Pagination";
import OrdersTable from "components/OrderTable/OrdersTable";
import Modal from "common/Modal/Modal";
import RadioButton from "common/RadioButton/RadioButton";
import { Select } from "common/Select/Select";
import { Input } from "common/Input/Input";
import { SelectItem } from "common/Select/SelectItem";
import TagInput from "common/TagInput/TagInput";
import FileUpload from "common/FileUpload/FileUpload";
import DatePicker from "common/DatePicker/DatePicker";
import axios from "axios";
import { serviceConfig } from "configs";
import { ReactComponent as LangIcon } from "common/assets/flags/tk.svg";
import { ReactComponent as ThemeIcon } from "common/assets/icons/moon-stars.svg";
import { ReactComponent as NotificationIcon } from "common/assets/icons/bell.svg";
import { ReactComponent as AvatarIcon } from "common/assets/icons/user.svg";
import MultiSelect from "common/MultiSelect/MultiSelect";
import { SearchInput } from "common/Search/Search";

const breadcrumbItems = [
	{ label: "Daşarky resminamalar", path: routeConstants.root.route },
	{ label: "Gelenler" },
];

const ExternalIncomingPage: React.FC = (): JSX.Element => {
	const userString = localStorage.getItem("user");
	const user = userString ? JSON.parse(userString) : null;

	const userId = user ? user?.user?._id : null; // Replace with actual user ID
	const userTypeId = user ? user?.user.userTypeId?._id : null;
	const numericUserTypeId = parseInt(userTypeId);
	const [currentPage, setCurrentPage] = useState(1);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [dghLetters, setDghLetters] = useState([]);
	const [recentDghLetters, setRecentDghLetters] = useState<any>([]);
	const [dghLettersByStatus, setDghLettersByStatus] = useState<any>([]);
	const [currentView, setCurrentView] = useState("all");
	const [totalPages, setTotalPages] = useState(0);
	const [lettersOptions, setLettersOptions] = useState([]);
	const [selectedFiles, setSelectedFiles] = useState([]);
	const [searchValue, setSearchValue] = useState("");

	const openModal = () => setIsModalOpen(true);
	const closeModal = () => setIsModalOpen(false);

	const itemsPerPage = 10;

	const fetchDGHLetters = async () => {
		try {
			const response = await axios.get(`${serviceConfig.apiUrl}/dgh/${userId}`);
			if (response.data.success) {
				// Set original data to dghLetters
				setDghLetters(response.data.data);
				setTotalPages(Math.ceil(response.data.data.length / itemsPerPage));

				// Format the data for lettersOptions
				const formattedOptions = response.data.data.map((letter: any) => {
					// Assuming you want to combine certain fields for the option label
					return {
						value: letter._id, // Assuming _id is the unique identifier
						label: `${letter.receivedNumber} - ${letter.fromWho} - ${letter.fromWhere}`, // Example format
					};
				});

				// Set formatted data to lettersOptions
				setLettersOptions(formattedOptions);
			}
		} catch (error) {
			console.error("Error fetching DGH letters:", error);
		}
	};

	// Fetch Recent DGH letters
	const fetchRecentDGHLetters = async () => {
		try {
			const response = await axios.get(
				`${serviceConfig.apiUrl}/dgh-new/${userId}`
			);
			setRecentDghLetters(response.data.data);
		} catch (error) {
			console.error("Error fetching recent DGH letters:", error);
		}
	};

	// Fetch DGH letters by status
	const fetchDGHLettersByStatus = async () => {
		try {
			const response = await axios.get(
				`${serviceConfig.apiUrl}/dgh-status/${userId}`
			);
			setDghLettersByStatus(response.data.data);
		} catch (error) {
			console.error("Error fetching DGH letters by status:", error);
		}
	};

	useEffect(() => {
		fetchDGHLetters();
		fetchRecentDGHLetters();
		fetchDGHLettersByStatus();
	}, []);

	const handleTabChange = (view: any) => {
		setCurrentView(view);
		switch (view) {
			case "all":
				setTotalPages(Math.ceil(dghLetters.length / itemsPerPage));
				break;
			case "recent":
				setTotalPages(Math.ceil(recentDghLetters.length / itemsPerPage));
				break;
			case "status":
				setTotalPages(Math.ceil(dghLettersByStatus.length / itemsPerPage));
				break;
			default:
				break;
		}
	};

	// Function to determine which data to display
	const getCurrentData = () => {
		let data;
		switch (currentView) {
			case "all":
				data = dghLetters;
				break;
			case "recent":
				data = recentDghLetters;
				break;
			case "status":
				// Extracting the 'letterId' details for 'recent' and 'status' tabs
				data = dghLettersByStatus;
				break;
			default:
				data = [];
		}
		return data.slice(
			(currentPage - 1) * itemsPerPage,
			currentPage * itemsPerPage
		);
	};

	const getDataLength = () => {
		switch (currentView) {
			case "all":
				return dghLetters.length;
			case "recent":
				return recentDghLetters.length;
			case "status":
				return dghLettersByStatus.length;
			default:
				return 0;
		}
	};

	const currentOrders = getCurrentData();

	const handleRowClick = (order: any) => {
		console.log("OPENED");
		// navigate(`/account/orders/${order._id}`);
	};

	const [formData, setFormData] = useState<any>({
		typeSide: "", // Assuming this is a field like 'Administrative' or 'Personal'
		letterType: "",
		fromWhere: "",
		fromWho: "",
		sentNumber: "",
		sentDate: "", // Format these dates as 'YYYY-MM-DD'
		receivedDate: "",
		deadlineDate: "",
		note: "",
		tags: [], // Assuming tags are an array of strings
		files: [], // This will hold file data
		selectedFiles: [],
		receivedNumber: "",
	});

	console.log("FORM DATA", formData);

	const handleInputChange = (e: any) => {
		const { name, value, type, checked } = e.target;

		if (type === "radio" && checked) {
			setFormData((prevState: any) => ({ ...prevState, [name]: value }));
		} else if (type !== "radio") {
			setFormData((prevState: any) => ({ ...prevState, [name]: value }));
		}
	};

	const handleSelect = (value: any) => {
		setFormData((prevState: any) => ({ ...prevState, letterType: value }));
	};

	const handleSelectFiles = (value: any) => {
		setFormData((prevState: any) => ({ ...prevState, selectedFiles: value }));
	};

	const handleFileChange = (e: any) => {
		if (e.target.files) {
			const filesArray = Array.from(e.target.files);
			setFormData((prevState: any) => ({
				...prevState,
				files: filesArray,
			}));
		}
	};

	const handleTagsChange = (tags: any) => {
		setFormData((prevState: any) => ({ ...prevState, tags }));
	};

	// Update this function to handle date picker changes
	const handleDateChange = (name: string, date: string) => {
		setFormData((prevState: any) => ({ ...prevState, [name]: date }));
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();

		const data = new FormData();
		Object.keys(formData).forEach((key) => {
			if (key === "files") {
				formData[key].forEach((file: File) => {
					data.append("files", file);
				});
			} else {
				if (key === "tags") {
					data.append(key, JSON.stringify(formData[key]));
				} else {
					data.append(key, formData[key]);
				}
			}
		});
		selectedFiles.forEach((filePath: string) => {
			data.append("providedFiles", filePath);
		});

		data.append("currentUserId", userId);

		try {
			const response = await axios.post(`${serviceConfig.apiUrl}/dgh`, data, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			setFormData({
				typeSide: "",
				letterType: "",
				fromWhere: "",
				fromWho: "",
				sentNumber: "",
				sentDate: "",
				receivedDate: "",
				deadlineDate: "",
				note: "",
				tags: [],
				files: [],
			});
			closeModal();
			window.location.reload();
		} catch (error) {
			console.error("Error submitting form:", error);
		}
	};

	const handleMultiSelect = (selectedValues: any) => {
		// selectedValues should be an array of the selected options' values
		setSelectedFiles(selectedValues);
	};

	const handleSearchChange = async (e: any) => {
		const value = e.target.value;
		setSearchValue(value); // Update the searchValue state

		try {
			if (value.trim() === "") {
				// Reset to default data if search input is cleared
				fetchDGHLetters();
			} else {
				// Perform the search with multiple fields
				const response = await axios.get(`${serviceConfig.apiUrl}/dgh/search`, {
					params: {
						query: value,
					},
				});
				setDghLetters(response.data.data);
				setTotalPages(Math.ceil(response.data.data.length / itemsPerPage));
			}
		} catch (error) {
			console.error("Error during search:", error);
		}
	};

	return (
		<div className="grid grid-cols-1 gap-4">
			<div className="grid grid-cols-1 gap-4 px-6 py-3 place-items-end">
				{/* <LangIcon />
					<ThemeIcon />
					<div className="relative">
						<NotificationIcon />
						<div className="absolute top-[-5px] right-[-5px] grid px-[0.4rem] py-[0.1rem] rounded-full place-items-center place-content-center bg-redColor">
							<P size="t2" type="semibold" className="text-white">
								4
							</P>
						</div>
					</div> */}
				<div className="grid gap-3 grid-cols-maxTwo place-items-center">
					<div className="p-2 rounded-full bg-grayOne">
						<AvatarIcon />
					</div>
					<div className="grid">
						<P size="t1" type="medium">
							{user ? `${user.user.name.charAt(0)}.${user.user.sirname}` : ""}
						</P>
						<P size="t2" type="regular" className="text-grayTwo">
							{user ? user.user.userTypeId?.positionName : ""}
						</P>
					</div>
				</div>
			</div>
			<div className="grid grid-flow-row auto-rows-max pb-7 gap-6 px-6 min-h-[90vh]">
				<Breadcrumbs items={breadcrumbItems} />
				<div className="grid grid-cols-maxTwo place-content-between place-items-center">
					<div className="grid gap-4 grid-cols-maxTwo">
						<div className="grid grid-cols-maxThree h-max">
							<div
								className={`min-w-[88px] text-center px-4 py-2 ${
									currentView === "all"
										? "border rounded-l-md border-mainColor bg-mainGradient"
										: "border rounded-l-md border-mainColor bg-white"
								} cursor-pointer`}
								onClick={() => handleTabChange("all")}
							>
								<P
									size="p3"
									type="medium"
									className={`${
										currentView === "all" ? "text-white" : "text-mainColor"
									} cursor-pointer`}
								>
									Hemmesi ({dghLetters.length})
								</P>
							</div>
							<div
								className={`min-w-[88px] text-center px-4 py-2 ${
									currentView === "recent"
										? "bg-mainGradient border-y border-mainColor"
										: "bg-white border-y border-mainColor"
								}  cursor-pointer`}
								onClick={() => handleTabChange("recent")}
							>
								<P
									size="p3"
									type="medium"
									className={`cursor-pointer ${
										currentView === "recent" ? "text-white" : "text-mainColor"
									} `}
								>
									Täze
								</P>
							</div>
							<div
								className={`min-w-[88px] text-center px-4 py-2 ${
									currentView === "status"
										? "bg-mainGradient border rounded-r-md border-mainColor"
										: "bg-white border rounded-r-md border-mainColor"
								} cursor-pointer`}
								onClick={() => handleTabChange("status")}
							>
								<P
									size="p3"
									type="medium"
									className={`cursor-pointer ${
										currentView === "status" ? "text-white" : "text-mainColor"
									}`}
								>
									Talap edildi
								</P>
							</div>
						</div>
						<SearchInput
							placeholder="Gözle"
							value={searchValue}
							onChange={handleSearchChange}
						/>
					</div>

					{numericUserTypeId === 11 && (
						<Button
							appearance="main"
							paddingY="py-2"
							className="h-max"
							icon={<AddLetterIcon />}
							onClick={openModal}
						>
							Haty hasaba almak
						</Button>
					)}
				</div>
				<Modal
					isOpen={isModalOpen}
					onClose={closeModal}
					title="Haty hasaba almak"
				>
					<div className="grid grid-flow-row grid-cols-1 gap-6 auto-rows-max">
						<div className="grid grid-flow-row grid-cols-1 gap-4 auto-rows-max">
							<P size="t1" type="regular">
								Tarapyň görnüşi
							</P>
							<div className="grid gap-6 grid-cols-maxTwo">
								<RadioButton
									id="administrative"
									name="typeSide"
									value="Administrative"
									label="Edara görnüşli tarap"
									onChange={handleInputChange}
									checked={formData.typeSide === "Administrative"}
								/>
								<RadioButton
									id="personal"
									name="typeSide"
									value="Personal"
									label="Şahsy tarap"
									onChange={handleInputChange}
									checked={formData.typeSide === "Personal"}
								/>
							</div>
						</div>
						<div className="grid grid-cols-2 gap-4 place-items-center">
							<Select
								label="Hatyň görnüşi"
								onSelect={handleSelect}
								defaultSelectLabel=""
							>
								<SelectItem value="Arza">Arza</SelectItem>
								<SelectItem value="Şertnama">Şertnama</SelectItem>
								<SelectItem value="Tender">Tender</SelectItem>
								<SelectItem value="Şertnama">Şertnama</SelectItem>
							</Select>
							<Input
								appearance="default"
								type="text"
								name="fromWhere"
								withlabel={true}
								label="Nireden gelen"
								value={formData.fromWhere}
								onChange={handleInputChange}
							/>
						</div>
						<div className="grid grid-cols-2 gap-4 place-items-center">
							<Input
								appearance="default"
								type="text"
								name="fromWho"
								withlabel={true}
								label="Kimden gelen"
								value={formData.fromWho}
								onChange={handleInputChange}
							/>

							<Input
								appearance="default"
								type="text"
								name="sentNumber"
								withlabel={true}
								label="Iberilen belgisi"
								value={formData.sentNumber}
								onChange={handleInputChange}
							/>
						</div>

						<div className="grid grid-cols-2 gap-4 place-items-center">
							<DatePicker
								label="Iberilen senesi"
								onDateChange={(date) => handleDateChange("sentDate", date)}
							/>
							<DatePicker
								label="Gelen senesi"
								onDateChange={(date) => handleDateChange("receivedDate", date)}
							/>
						</div>

						<div className="grid grid-cols-2 gap-4 place-items-center">
							<DatePicker
								label="Ýerine ýetirilmeli soňky senesi"
								onDateChange={(date) => handleDateChange("deadlineDate", date)}
							/>
							<Input
								appearance="default"
								type="text"
								name="receivedNumber"
								withlabel={true}
								label="Kabul ediş belgisi"
								value={formData.receivedNumber}
								onChange={handleInputChange}
							/>
						</div>

						<div className="grid grid-cols-1">
							<Input
								appearance="default"
								type="text"
								name="note"
								withlabel={true}
								label="Gysgaça beýany"
								value={formData.note}
								onChange={handleInputChange}
							/>
						</div>
						<div className="grid grid-cols-1">
							<TagInput
								placeholder=""
								label="Degişli teglar"
								onChange={handleTagsChange}
							/>
						</div>
						<div className="grid grid-cols-1">
							<FileUpload
								files={formData.files}
								onChange={handleFileChange}
								label="Ýüklenilýän faýllar"
							/>
						</div>

						<MultiSelect
							label="Bagly hatlar"
							options={lettersOptions} // Assuming fileOptions is fetched from your API
							onSelect={handleMultiSelect}
						/>

						<Button
							appearance="main"
							className="place-self-end"
							paddingX="px-5"
							paddingY="py-[10px]"
							onClick={handleSubmit}
						>
							Ýatda sakla
						</Button>
					</div>
				</Modal>
				<div>
					<OrdersTable
						orders={currentOrders}
						onRowClick={handleRowClick}
						type="dgh"
					/>
					<div className="grid grid-cols-maxTwo place-content-between place-items-center py-[14px] px-[20px] border-x border-b border-strokeColor rounded-b-md">
						<P size="t2" type="regular" className="text-grayTwo">
							Jemi {getDataLength()} sany
						</P>
						<Pagination
							currentPage={currentPage}
							totalPages={totalPages}
							onPageChange={setCurrentPage}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ExternalIncomingPage;
